import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import {
  Collection,
  ExecuteOperationOnPipe,
  ModelWithForm,
  TriggerPipelineOnFormSubmit,
  WhenModel
} from '@morningtrain/react-resources'
import { MountSmartviewWithModelOnClick } from '@morningtrain/react-smartviews'
import { Pipeline } from '@morningtrain/react-pipelines'
import { Fieldset } from 'layouts'
import * as Fields from 'support/fields'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import ModelValueTitle from 'widgets/ModelValueTitle'
import TableHeader from '../../../ui/table/TableHeader'
import FileSmartview from 'widgets/smartviews/inventory/FileSmartview'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { NavigateOnPipe, useRouter } from '@morningtrain/react-navigation'
import { ModelValueFilter, PaginationFilter } from '@morningtrain/react-filters'
import * as Displays from 'support/displays'
import { Can } from '@morningtrain/react-auth'
import { SelectedDepartmentFilter } from 'support/filters'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'

export default function ManageEmployeeFileTag () {
  const router = useRouter()
  const fileTagId = router.parameter('file_tag')

  return (
    <AdminPageWithSmartview>
      <Translator namespace='files.employee_files'>

        <ModelWithForm resourceName='files.tags' operationName='read'>

          <WhenModel>

            <UI.PageHeader title={<ModelValueTitle name='name'/>}>
              <UI.ButtonWrap>
                <DeleteModelOnClick
                  pipes={(
                    <>
                      <NavigateOnPipe route='app.files.employee_files.manage'/>
                    </>
                  )}
                >
                  <UI.SquareButton color='red' big>
                    <UI.Icons.Trash className='w-4 h-4'/>
                  </UI.SquareButton>
                </DeleteModelOnClick>
                <UI.SubmitButton>
                  <Translation name='generic.save'/>
                </UI.SubmitButton>

                <Pipeline>
                  <TriggerPipelineOnFormSubmit/>
                  <ExecuteOperationOnPipe operationName='index'/>
                </Pipeline>
              </UI.ButtonWrap>
            </UI.PageHeader>

            <UI.CardGroup>
              <UI.Card>
                <Fieldset cols={2}>
                  <Fields.Input
                    name='name_da'
                    label={<Translation name='fields.name_translations.da.label'/>}
                  />
                  <Fields.Input
                    name='name_en'
                    label={<Translation name='fields.name_translations.en.label'/>}
                  />
                  <Fields.File
                    name='thumbnail'
                    label='Thumbnail'
                  />
                </Fieldset>
              </UI.Card>

              <UI.Card>
                <Fieldset cols={2}>
                  <Fields.ResourceSelector
                    name='employment_type_ids'
                    optionsKey='name'
                    multiple
                    placeholder='-'
                    resourceName='employments.employment_type'
                    label={<Translation name='fields.employment_types.label'/>}
                    operationName='select'
                  />
                  <Can permission='api.onboarding.onboarding_checklist_templates.index'>
                    <Fields.ResourceSelector
                      name='onboarding_checklist_template_ids'
                      optionsKey='name'
                      multiple
                      placeholder='-'
                      resourceName='onboarding.onboarding_checklist_templates'
                      label={<Translation name='fields.onboarding_checklists.label'/>}
                      operationName='index'
                    />
                  </Can>
                </Fieldset>
              </UI.Card>

              <UI.Card>
                <TableHeader>
                  <UI.SecondaryHeading>
                    <Translation name='titles.files'/>
                  </UI.SecondaryHeading>
                  <MountSmartviewOnClick smartview={<FileSmartview fileTagId={fileTagId}/>}>
                    <UI.Button>
                      <Translation name='actions.upload'/>
                    </UI.Button>
                  </MountSmartviewOnClick>
                </TableHeader>
                <Collection resourceName='files.files'>
                  <ModelValueFilter name='file_tag_id' modelKey='id'/>
                  <SelectedDepartmentFilter/>

                  <Table>
                    <Columns.Column name='name' label={<Translation name='columns.name.label'/>}>
                      <Displays.DownloadFile name='url' filenameAttribute='file_name'>
                        <UI.Text className='cursor-pointer' weight='medium'>
                          <Displays.Text name='name'/>
                        </UI.Text>
                      </Displays.DownloadFile>
                    </Columns.Column>
                    <Columns.Text name='pretty_type' label={<Translation name='columns.type.label'/>}/>
                    <Columns.Column alignment='right'>
                      <MountSmartviewWithModelOnClick smartview={<FileSmartview fileTagId={fileTagId}/>}
                                                      replace={false}>
                        <UI.Button>
                          <Translation name='generic.actions.edit'/>
                        </UI.Button>
                      </MountSmartviewWithModelOnClick>
                    </Columns.Column>
                  </Table>

                  <PaginationFilter/>

                </Collection>
              </UI.Card>
            </UI.CardGroup>

          </WhenModel>

        </ModelWithForm>

      </Translator>
    </AdminPageWithSmartview>
  )
}
